import React, { useContext, useState } from "react"
import { withRouter, Redirect } from "react-router"
import { AuthContext } from "./Auth.js"
import logo from './agrari-styles/logo 1v.png';
import { Image,Loader,Dimmer } from 'semantic-ui-react';
import bgImage from './agrari-styles/Vector.png'
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

const Login = ({ history }) => {
  const [loader, changeLoader] = useState(false)
  const [email, setEmail] = useState('')
  const [pswrd, setPswrd] = useState('')
  const auth = firebase.auth();
  const { currentUser } = useContext(AuthContext)

  const handleLogin = (e) => {
    e.preventDefault();
    changeLoader(true)
    
    auth.signInWithEmailAndPassword( email, pswrd)
    .then((userCredential) => {
      // User successfully signed in
      const user = userCredential.user;
      console.log('User signed in:', user);
    })
    .catch((error) => {
      // An error occurred during sign in
      const errorCode = error.code;
      const errorMessage = error.message;
      console.error('Sign-in error:', errorCode, errorMessage);
      changeLoader(false)
      alert("Correo o Contraseña incorrectas");
    });
  }



  if (currentUser) {
    return <Redirect to="/" />
  }

  return (
    <div  className="login"
      style={
      { backgroundImage: `url(${bgImage})`,
        backgroundSize: 'cover',
        overflow: 'hidden', 
      }}
    >
      <Dimmer active={loader}>
				<Loader className="loader" >Cargando...</Loader>
			</Dimmer>
      <div className="logo">
        <Image  src={logo} size='small' centered />
      </div>
      <form onSubmit={handleLogin}>
        <div className="Group5">
          <label >
            <input 
              className="loginInput"
              type="email" 
              placeholder="Correo"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>
          <br />
          <label >
            <input 
              className="loginInput"
              type="password" 
              placeholder="Contraseña"
              value={pswrd}
              onChange={(e) => setPswrd(e.target.value)}
            />
          </label>
        </div>
        <button className="" type="submit">Ingresar</button>
        <button className="registerCompanyButton" type="button" onClick={() => history.push('/registro')}>
          Crear cuenta
        </button>
      </form>
    </div>
  );
};

export default withRouter(Login)
